'use client';

import React, { useContext } from 'react';
import cn from 'classnames';
import map from 'lodash/map';
import styles from './sidebarPanel.module.scss';
import { getTopicIconByID } from '@/utils/helpCenterUtils';
import OHCContext from '@/providers/OHCContext';
import Link from 'next/link';
import { useTrack } from '@chewy/use-analytics';
export interface SidebarPanelProps {
  readonly sectionsData: any[];
  readonly selectedTopic?: any;
  readonly categoryIds?: any;
}

const SidebarPanel: React.FC<SidebarPanelProps> = ({ sectionsData = [], categoryIds = {} }) => {
  const { selectedTopic, setSelectedTopic, setSelectedSection, setSelectedArticle, isDesktopMode } = useContext(OHCContext);

  const track = useTrack();
  const handleTopicClick = (section: any) => {
    setSelectedTopic(section);
    setSelectedSection(null);
    setSelectedArticle(null);
    const eventProperties = {
      id: 'sidebar-topic-button-id',
      parentId: 'sidebar-id',
      level: 'sidebar',
      type: 'static',
      position: 1,
      topicId: section?.id,
      title: section?.title,
      categoryId: section?.categoryId,
      event_name: 'Sidebar Button Clicked',
      eventAction: 'click',
      eventCategory: 'help-center-landing-page',
      eventLabel: 'help-center-landing-page-click'
    };
    track('Sidebar Button Clicked', eventProperties);
  };

  if (!isDesktopMode) {
    return null;
  }

  return (
    <div className={styles.sidebar}>
      <nav className={styles.navigation} role="navigation" aria-label="Help Center Topics">
        {map(sectionsData, section => {
          const isSelected = selectedTopic?.id === section?.id;
          const sectionIcons = getTopicIconByID(section.categoryId, categoryIds);
          return (
            <Link
              href={`/customer-care/${section.id}`}
              key={section.id}
              className={cn(styles.navItem, {
                [styles.selectedNavItem as string]: isSelected
              })}
              onClick={() => handleTopicClick(section)}
              aria-current={isSelected ? 'page' : undefined}
              prefetch={true}
            >
              <div className={styles.navIcon} aria-hidden="true">
                {sectionIcons?.start}
              </div>
              {section.title}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default SidebarPanel;
